import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'primereact/button';
import { FileUpload, FileUploadHeaderTemplateOptions, FileUploadSelectEvent, ItemTemplateOptions } from 'primereact/fileupload';
import { Galleria, GalleriaResponsiveOptions } from 'primereact/galleria';
import { Image } from 'primereact/image';
import { ProgressBar } from 'primereact/progressbar';
import { Tag } from 'primereact/tag';
import { Tooltip } from 'primereact/tooltip';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useToast } from '../../../../Shared/hook/useToast';
import productViewModel from "./ProductViewModel";

export interface ProductGallery {
    itemImageSrc: string;
    thumbnailImageSrc: string;
    alt: string;
    title: string;
    id: any;
}
export const AddImages = () => {
    const responsiveOptions: GalleriaResponsiveOptions[] = [
        {
            breakpoint: '991px',
            numVisible: 4
        },
        {
            breakpoint: '767px',
            numVisible: 3
        },
        {
            breakpoint: '575px',
            numVisible: 1
        }
    ];

    const MAX_MB = 10;
    const MAX_BYTES = MAX_MB * 1024 * 1024;
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
 
    // const baseURL = `${Environment.apiUrl}/product`;
    const { id } = useParams();
    const { showSuccess, showError, showWarn, showInfo } = useToast();

    const location = useLocation();
    const { nombreProducto } =  location.state || "";

    // const toast = useRef<Toast>(null);
    const [totalSize, setTotalSize] = useState(0);
    const fileUploadRef = useRef<FileUpload>(null);
    const [gallery, setGallery] = useState<ProductGallery[]>([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [viewGallerySlider, setViewGallerySlider] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [mainImg, setMainImg] = useState<any>({});
    const [viewMainImage, setViewMainImage] = useState<string>("");

    const load = () => {
        setLoading(true);

        setTimeout(() => {
            setLoading(false);
        }, 2000);
    };

    console.log("ID desde página AddImages", id);

    const {
        uploadtGallery,
        ViewGalleryById,
        SetMainImageGallery,
        MainImage,
        deleteProductGallery
        } = productViewModel();


        const fetchGallery = async () => {
            try {
                const result = await ViewGalleryById(id);

                console.log("result", result);

                if(result.length>0){
                    // Mapeo de los datos a ProductGallery
                    const mappedImages: ProductGallery[] = result.map((item: any) => ({
                        itemImageSrc: `${item.slug}`, // Ajusta esta URL según tu servidor
                        thumbnailImageSrc: `${item.slug}`, // Si tienes miniaturas
                        alt: `Imagen del producto`,
                        title: `Producto`,
                        id: item.id
                    }));
                    setViewGallerySlider(true);
                    setGallery(mappedImages);
                }else{
                    setViewGallerySlider(false);
                    setGallery([]);
                }
            } catch (error) {
                console.error("Error fetching gallery:", error);
            }
        };
        
       useEffect(() => {
        
        if(id){
            fetchGallery();
            LoadMainImage();
            
        }
    
           // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [id]);

           const deleteItemGalery = async (data: any) => {
                try {
                    const resp = await deleteProductGallery(Number(data.id));
                    if (resp) {
                        showSuccess("Éxito", "Imagen eliminado correctamente.");
                         if(id){
                            fetchGallery();
                            LoadMainImage();
                            setViewMainImage("");
                        }

                    }
                    console.log("API Load Main Image:", mainImg);
                } catch (error) {
                    console.error('Error al establecer la imagen principal:', error);
                }
           }

           const LoadMainImage = async () => {
            try {
                const resp = await MainImage(id);
                if (resp) {
                    setViewMainImage(resp.toString());
                    console.log(resp.toString());
                }
            
                console.log("API Load Main Image:", mainImg);
            } catch (error) {
                console.error('Error al establecer la imagen principal:', error);
            }
        };
        

    // Maneja la selección de archivos
    // const onTemplateSelect = (e: FileUploadSelectEvent) => {
    //     let _totalSize = totalSize;
    //     let files = e.files;

    //     for (let i = 0; i < files.length; i++) {
    //         _totalSize += files[i].size || 0;
    //     }

    //     setTotalSize(_totalSize);

    //     const maxSize = MAX_BYTES; // Tamaño máximo permitido en bytes
    //     if (_totalSize > maxSize) {
    //         showWarn("Advertencia", "El tamaño total de las imágenes seleccionadas supera el límite permitido de 2 MB.");
    //     }
    // };

const onTemplateSelect = (e: FileUploadSelectEvent) => {
    let _totalSize = totalSize;
    let newValidFiles: File[] = [...selectedFiles];

    let duplicateDetected = false;

    for (let file of e.files) {
        const exists = newValidFiles.some(f =>
            f.name === file.name &&
            f.size === file.size &&
            f.lastModified === file.lastModified
        );

        if (exists) {
            duplicateDetected = true;
            continue;
        }

        _totalSize += file.size || 0;
        newValidFiles.push(file);
    }

    // 🔥 mostrar solo si realmente se intentó agregar algo nuevo duplicado
    if (duplicateDetected && e.files.length === 1) {
        showWarn("Advertencia", "Este archivo ya fue seleccionado.");
    }

    setSelectedFiles(newValidFiles);
    setTotalSize(_totalSize);
};

const onCustomUpload = async () => {

    const sizeMaxImg = 5 * 1024 * 1024;
    if (!id) {
        showError("Error", "ID del producto no encontrado.");
        return;
    }

    if (selectedFiles.length === 0) {
        showWarn("Advertencia", "No hay archivos válidos para subir.");
        return;
    }

    // 🔴 VALIDACIÓN NUEVA (CLAVE)
    const invalidFiles = selectedFiles.filter(
    (file, index, self) =>
        file.size > sizeMaxImg &&
        index === self.findIndex(f =>
            f.name === file.name &&
            f.size === file.size
        )
);

    // invalidFiles.forEach(file => {
    //     console.log(`Archivo inválido: ${file.size}`);
    // });

    if (invalidFiles.length > 0) {
        showWarn(
            "Advertencia",
            `Tienes ${invalidFiles.length > 1 ? invalidFiles.length + ' imágenes' : invalidFiles.length + ' imagen'} que  ${invalidFiles.length > 1 ? ' superan' : 'supera'}  los 5MB permitido por cada uno. Elimínalos antes de subir.`
        );
        return;
    }

    // (opcional) validar tamaño total también
    const total = selectedFiles.reduce((acc, f) => acc + f.size, 0);

    if (total > MAX_BYTES) {
        showError("Error", "El tamaño total supera el límite permitido.");
        return;
    }

    // ✅ CONTINÚA NORMAL
    const formData = new FormData();

    selectedFiles.forEach((file) => {
        formData.append("Images", file);
    });

    formData.append("ProductId", id);

    try {
        const response = await uploadtGallery(formData);

        if (response === true) {
            showSuccess("Éxito", "Imágenes subidas correctamente.");

            fileUploadRef.current?.clear();
            setSelectedFiles([]);
            setTotalSize(0);

            fetchGallery();
            LoadMainImage();
        } else {
            showError("Error", "Error al subir imágenes.");
        }
    } catch (error) {
        showError("Error", "No se pudieron subir las imágenes");
    }
};
    // Maneja la eliminación de archivos
const onTemplateRemove = (file: File, callback: Function) => {
    const updatedFiles = selectedFiles.filter(f => 
        !(f.name === file.name && f.size === file.size && f.lastModified === file.lastModified)
    );

    const newSize = updatedFiles.reduce((acc, f) => acc + f.size, 0);

    setSelectedFiles(updatedFiles);
    setTotalSize(newSize);

    callback();
};

    // Maneja el vaciado de la selección
    const onTemplateClear = () => {
        // setSelectedFiles([]);
        // fileUploadRef.current?.clear();
        setTotalSize(0);
    };
    const itemTemplateSlider = (item: any) => {
         if (!item) return null;
        return <>
        <Button className='btn btn-danger mb-2 delete-item-galery' onClick={() => deleteItemGalery(item)}><FontAwesomeIcon icon={icon({name: 'trash'})} /></Button>
        <img src={item.itemImageSrc ?? ""} alt={item.alt} style={{ width: '100%', display: 'block' }} />
         <Button label="Elegir" severity="secondary" icon="pi pi-check" loading={loading} onClick={()=>{handleMainImage();load()}} className='btn-choose-main-image' rounded />
        </>
    }
    const thumbnailTemplate = (item: any) => {
         if (!item) return null;
        return <img
                src={item.thumbnailImageSrc ?? ""}
                alt={item.alt}
                style={{ display: 'block', width: '200px' }}
                onClick={() => handleImageClick(item)}
                />
       
    }
    const handleImageClick = (galleryId: any) => {
        const productId = id;
        const data = {
            productId: productId,
            galleryId: galleryId.id
            
        }
        setMainImg(data);
        // setViewMainImage(galleryId.itemImageSrc);
        
    };
    const handleMainImage = async () => {
        try {
            const resp = await SetMainImageGallery(mainImg);
            if (resp) {
                setViewMainImage(resp.toString());
                showSuccess("Éxito", "Imagen principal establecida");
            }
            console.log("API Main Image:", mainImg);
        } catch (error) {
            console.error('Error al establecer la imagen principal:', error);
        }
    };


    // Plantilla del header del `FileUpload`
    const headerTemplate = (options: FileUploadHeaderTemplateOptions): JSX.Element => {
        const { className, chooseButton, uploadButton, cancelButton } = options;
        const value = fileUploadRef.current ? totalSize / (MAX_MB * 1024 * 1024) * 100 : 0; // Convertir a porcentaje para la barra de progreso
        const formatedValue = fileUploadRef.current ? fileUploadRef.current.formatSize(totalSize) : '0 B';

        return (
            <>
            <div className='row'>
                <div className="col-lg-6 col-md-6 col-sm-12 text-start pt-3">
                    <h2 className='name-pro-galery'>Imágenes de {nombreProducto}</h2>
                    <ul className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a href="/home" className="text-danger"><FontAwesomeIcon icon={icon({name: 'home'})} /></a>
                        </li>
                        <li className="breadcrumb-item">
                            <a href="/products" className="text-danger">Lista Productos</a>
                        </li>
                        <li className="breadcrumb-item">Añadir imágenes</li>
                    </ul>
                </div>
            </div>
             <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                {uploadButton}
                {cancelButton}
                <div className="flex align-items-center gap-3 ml-auto">
                    <span>{formatedValue} / {MAX_MB} MB</span>
                    <ProgressBar value={value} showValue={false} style={{ width: '10rem', height: '12px' }}></ProgressBar>
                </div>
            </div>
            </>
           
        );
    };

    // Plantilla de los ítems subidos
    const itemTemplate = (inFile: object, props: ItemTemplateOptions): JSX.Element => {
        const file = inFile as File;

        const MAX_FILE_BYTES = 5 * 1024 * 1024;
        const isInvalid = file.size > MAX_FILE_BYTES;

        return (
            <div className={`flex align-items-center flex-wrap content-item-galery ${isInvalid ? 'border border-danger surface-border p-2 border-round mb-2' : ''}`}>
                <div className="flex align-items-center" style={{ width: '40%' }}>
                    <img alt={file.name} role="presentation" src={URL.createObjectURL(file)} width={100} />
                    <span className="flex flex-column text-left ml-3">
                        {file.name}
                        <small>{new Date().toLocaleDateString()}</small>
                    </span>
                </div>
                 
                 {isInvalid && (
                    <span 
                        className="delete-img-size-warning bg-danger text-white border-round" 
                    > Eliminar imagen grande, sólo se permite menor de 5MB por cada uno</span>
                )}
               
                    <Tag value={props.formatSize} severity="warning" className="px-3 py-2" />&nbsp;&nbsp;
                    <Button type="button" icon="pi pi-times" className="p-button-outlined p-button-rounded p-button-danger ml-auto" 
                    onClick={() => onTemplateRemove(file, props.onRemove)} />
               
                
            </div>
        );
    };

    // Plantilla cuando no hay archivos
    const emptyTemplate = () => {
        return (
            <div className="flex align-items-center flex-column">
                <i className="pi pi-image mt-3 p-5" style={{ fontSize: '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                <span style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)' }} className="my-5">
                    Arrastre y suelte la imagen aquí
                </span>
            </div>
        );
    };

    // Opciones de botones personalizados
    const chooseOptions = { icon: 'pi pi-fw pi-images', iconOnly: true, className: 'custom-choose-btn p-button-rounded p-button-outlined' };
    const uploadOptions = { icon: 'pi pi-fw pi-cloud-upload', iconOnly: true, className: 'custom-upload-btn p-button-success p-button-rounded p-button-outlined' };
    const cancelOptions = { icon: 'pi pi-fw pi-times', iconOnly: true, className: 'custom-cancel-btn p-button-danger p-button-rounded p-button-outlined' };

    return (
        <>
         <div className='col-lg-12'>
            {/* <Toast ref={toast}></Toast> */}

            <Tooltip target=".custom-choose-btn" content="Elegir" position="bottom" />
            <Tooltip target=".custom-upload-btn" content="Subir" position="bottom" />
            <Tooltip target=".custom-cancel-btn" content="Limpiar" position="bottom" />

            <FileUpload 
                ref={fileUploadRef}
                name="images"
                multiple 
                accept="image/*" 
                // maxFileSize={MAX_BYTES}
                // onValidationFail={(file) => {
                //     console.log("Archivo muy grande:", file.name);
                // }}
                customUpload 
                uploadHandler={onCustomUpload} 
                onSelect={onTemplateSelect} 
                onError={onTemplateClear} 
                onClear={onTemplateClear}
                headerTemplate={headerTemplate} 
                itemTemplate={itemTemplate} 
                emptyTemplate={emptyTemplate}
                chooseOptions={chooseOptions} 
                uploadOptions={uploadOptions} 
                cancelOptions={cancelOptions} 
            />
        </div>
        {viewGallerySlider && (
        <div className='row mt-3'>
            <div className='col-lg-6'>
        
                <div className="card">
            
                <Galleria 
                        value={gallery} 
                        activeIndex={activeIndex}
                        onItemChange={(e) => setActiveIndex(e.index)}
                        responsiveOptions={responsiveOptions}
                        numVisible={5} 
                        style={{ maxWidth: '100%', width: '100%'}}
                        item={itemTemplateSlider}
                        thumbnail={thumbnailTemplate}
                        showThumbnails={true}
                    />
                </div>
        
            </div>
            <div className='col-lg-6'>
                
                <div className="card flex justify-content-center flex-wrap justify-content-center gap-3 align-items-center p-3">
                    <h3>Imagen principal</h3>
                    {/* <Button label="Elegir" severity="secondary" icon="pi pi-check" loading={loading} onClick={()=>{handleMainImage();load()}} style={{ maxWidth: '100%', width: '300px'}} rounded /> */}
                    <Image src={viewMainImage} alt="Image" width="250" />
                </div>
            </div>
        </div>
        )}
        </>
       
    );
}
